import { Component, OnInit, ViewContainerRef } from '@angular/core';
import {
  ModalDialogService,
  IModalDialogButton,
  IModalDialog,
  IModalDialogOptions,
} from 'ngx-modal-dialog';
import { UtilsService } from '../../../services/utils.service';
import { ComponentRef } from '@angular/core';

@Component({
  selector: 'alg-products-energy-modal',
  templateUrl: './alg-products-energy-modal.component.html',
  styleUrls: ['./alg-products-energy-modal.component.scss'],
})
export class AlgProductsEnergyModalComponent implements OnInit {
  actionButtons: IModalDialogButton[];
  constructor(
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {}

  dialogInit(
    reference: ComponentRef<IModalDialog>,
    options: Partial<IModalDialogOptions<any>>
  ) {
    this.actionButtons = [
      {
        text: '',
        buttonClass: 'alg-btn-close',
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
    ];
    options.actionButtons = this.actionButtons;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/alg-products-energy-modal/alg-products-energy-modal.component.ts